import React from 'react';


// won't load server side so we need this
export default class RichTextEditor extends React.Component {

    constructor(props) {
        super(props);

        this._rteLoaded = false;
        this._RichTextEditor = (props) => {
            const {value, ...otherProps} = props;
            //console.log('in text editor with', value);
            return <textarea value={RichTextEditor.RTEValuetoString(value)} {...otherProps} />
         };
    }

    componentDidMount() {
        this._loadRTE();
    }

    componentWillUpdate(nextProps, nextState) {
        this._loadRTE();
    }

    _loadRTE() {
        if(!this._rteLoaded){
            this._rteLoaded = true;
            this._RichTextEditor = require('react-rte').default;
            this.forceUpdate();
        }
    }

    static RTEValuetoString(value) {

        if (value && typeof(value) !== 'string') {
            value = value.toString('html');
        }
        return value;
    }

    render() {

        const RichTextEditor = this._RichTextEditor;

        const {value, ...props} = this.props;

        let RTEValue = '';

        //convert to RTE format when RTE is loaded
        if(this._rteLoaded && (!value || typeof(value) === 'string')) {
            RTEValue = value ?
            RichTextEditor.createValueFromString(value, 'html')
            : RichTextEditor.createEmptyValue();
        } else {
            RTEValue = value;
        }

        return <RichTextEditor {...props} value={RTEValue}  />
    }

}



// WEBPACK FOOTER //
// ./webapp/components/elements/RichTextEditor.js